import React, { useEffect, useRef } from "react";
import { bool, func, string, object } from "prop-types";

import UploadIcon from "../../../../assets/icons/upload";
import DeleteIcon from "../../../../assets/icons/delete";
import "./profile-image-dropdown.m.css";

export const ProfileImageDropdown = ({
  isOpen,
  onClose,
  onUploadClick,
  onRemoveClick,
  hasImage = false,
  buttonRef,
  className = "",
  ...props
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      styleName="dropdown-container"
      className={className}
      {...props}
    >
      <div styleName="dropdown-option" onClick={onUploadClick}>
        <UploadIcon color='#8f8f8f' />
        <span styleName="option-text">Upload photo</span>
      </div>

      <div
        styleName={`dropdown-option ${!hasImage ? 'disabled' : ''}`}
        onClick={hasImage ? onRemoveClick : undefined}
      >
        <DeleteIcon />
        <span styleName="option-text">Remove photo</span>
      </div>
    </div>
  );
};

ProfileImageDropdown.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onUploadClick: func.isRequired,
  onRemoveClick: func,
  hasImage: bool,
  buttonRef: object,
  className: string
};